import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import SidePane from 'owa-calendar-sidepane/lib/component/SidePane';
import loc from 'owa-localize';
import { accessibilityCheckerHeader } from './FullComposeSidePane.locstring.json';
import { AccCheckerPane } from 'owa-editor-acc-checker';
import { updateSidePaneType } from 'owa-calendar-compose-form-actions';

const styles = require('./FullComposeSidePane.scss');
const classNames = require('classnames/bind').bind(styles);

export interface FullComposeAccCheckerSidePaneProps {
    formId: string | null;
}

const FullComposeAccCheckerSidePane: React.FunctionComponent<FullComposeAccCheckerSidePaneProps> = props => {
    const { formId } = props;

    const { currentSidePaneType, accChecker, bodyViewState } = getFullComposeViewState(formId);

    const isOpened =
        !!accChecker?.isOpen && currentSidePaneType == SidePaneType.AccessibilityChecker;

    const onClose = React.useCallback(() => {
        updateSidePaneType(formId, SidePaneType.None);
    }, [formId]);

    return (
        <SidePane title={loc(accessibilityCheckerHeader)} isOpened={isOpened} onClose={onClose}>
            <div className={classNames(styles.sidePane, styles.accCheckerPane)}>
                <AccCheckerPane viewState={accChecker} editorViewState={bodyViewState} />
            </div>
        </SidePane>
    );
};

export default observer(FullComposeAccCheckerSidePane);
